export const DEFAULT_SESSION_EXPIRED_MESSAGE = "Session expired. Please sign in again.";

export const AUTH_SESSION_EXPIRED_EVENT = "auth:session-expired";

type SessionExpiredDetail = {
  message: string;
};

let sessionExpiredDispatched = false;

export function emitSessionExpired(message = DEFAULT_SESSION_EXPIRED_MESSAGE) {
  if (sessionExpiredDispatched || typeof window === "undefined") return;

  sessionExpiredDispatched = true;
  window.dispatchEvent(
    new CustomEvent<SessionExpiredDetail>(AUTH_SESSION_EXPIRED_EVENT, {
      detail: { message },
    })
  );
}

export function resetSessionExpiredState() {
  sessionExpiredDispatched = false;
}

export function createSessionExpiredError(cause?: unknown) {
  const error = new Error(DEFAULT_SESSION_EXPIRED_MESSAGE) as Error & {
    code?: string;
    cause?: unknown;
  };

  error.code = "SESSION_EXPIRED";
  error.cause = cause;
  return error;
}
